
export default {
    name: 'workgroup_info',
    data: () => ({
        order_informations: [],
        loading_order_information: false,
        device_informations: [],
        loading_device_information: false,
        additional_informations: [],
        loading_additional_information: false,
    }),
    methods: {
        async getOrderInformations(workgroup_id) {
            this.loading_order_information = true;
            this.$communicator.then(
                this,
                await this.$communicator('get_order_informations', {
                    workgroup_id: workgroup_id
                })
            );
            this.loading_order_information = false;
        },
        async getDeviceInformations(workgroup_id) {
            this.loading_device_information = true;
            this.$communicator.then(
                this,
                await this.$communicator('get_device_informations', {
                    workgroup_id: workgroup_id
                })
            );
            this.loading_device_information = false;
        },
        async getAdditionalInformations(workgroup_id) {
            this.loading_additional_information = true;
            this.$communicator.then(
                this,
                await this.$communicator('get_additional_informations', {
                    workgroup_id: workgroup_id
                })
            );
            this.loading_additional_information = false;
        },
        async getWInfoHeaders(workgroup_id, type) {
            let key = 'workgroup_order_order_information_get';
            if(type == 'device') {
                key = 'workgroup_order_device_information_get'
            }
            else if(type == 'additional') {
                key = 'workgroup_order_additional_information_get'
            }
            return this.$communicator.then(
                this,
                await this.$communicator(key, {
                    params: {
                        workgroup_id: workgroup_id
                    }
                })
            );
        },
        async getWInfoData(workgroup_id, workgroup_order_id, type) {
            let key = 'workgroup_order_order_information_details';
            if(type == 'device') {
                key = 'workgroup_order_device_information_details'
            }
            else if(type == 'additional') {
                key = 'workgroup_order_additional_information_details'
            }
            return this.$communicator.then(
                this,
                await this.$communicator(key, {
                    params: {
                        workgroup_id: workgroup_id,
                        workgroup_order_id: workgroup_order_id
                    }
                })
            );
        },
    }
}
